import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Checkbox, FormControl, FormControlLabel, InputLabel, MenuItem, Radio, RadioGroup, Select, TextField, Tooltip, Typography } from "@mui/material";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

function BonificationPreferences() {

  return (
    <Box display='flex' flexDirection='row' justifyContent='center' sx={{ marginBlockEnd: '0.5rem'}} >
     <Accordion sx={{ width: '100%', boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px;'}}>
        <AccordionSummary
          expandIcon={<ArrowDownwardIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="span" variant="h6">Bonificações e Gratificações Aplicáveis a Motoristas</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{margin: '1rem'}}>
          <Box sx={{ display: 'flex', marginBlock: '1rem'}}>
            <Box sx={{ width: '50%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start'}}>
                <Typography variant="body1">Bonificações a disponibilizar</Typography>
                <Tooltip title="Open settings" sx={{ marginBlockStart: '0.2rem', marginInlineStart: '0.5rem'}}>
                  <InfoOutlinedIcon fontSize="small" />
                </Tooltip>
              </Box>
            </Box>
            <Box sx={{ margin: '0rem 1rem 0 1rem', width: '50%', display: 'flex', justifyContent: 'flex-start'}}>
              <FormControl size="small" sx={{ minWidth: 180, width: '100%', bgcolor: 'white' }} fullWidth>
                  <InputLabel size='small'>Bonificações</InputLabel>
                  <Select
                      size="small"
                      value={'0'} displayEmpty required={true} label={"Bonificações"}>
                      <MenuItem value={'Transol'}>Todos</MenuItem>
                      <MenuItem value={'Cityrama'}>Anabela</MenuItem>
                      <MenuItem value={'Rodest'}>Eunildes</MenuItem>
                  </Select>
              </FormControl>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', marginBlock: '1rem' }}>
            <Box sx={{ width: '50%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start'}}>
                <Typography variant="body1">Regras de bloqueio de Bonificações</Typography>
                <Tooltip title="Open settings" sx={{ marginBlockStart: '0.2rem', marginInlineStart: '0.5rem'}}>
                  <InfoOutlinedIcon fontSize="small"/>
                </Tooltip>
              </Box>
            </Box>
            <Box sx={{margin: '0rem 1rem 0 1rem', width: '50%' }}>
              <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start'}}>
                <FormControl size="small" sx={{ minWidth: 180, width: '100%', bgcolor: 'white', marginInlineEnd: '0.1rem' }} fullWidth>
                  <InputLabel>Quando Selecionado</InputLabel>
                  <Select
                      size="small"
                      value={'0'} displayEmpty required={true} label={"Quando Selecionado"}>
                      <MenuItem value={'Transol'}>Todos</MenuItem>
                      <MenuItem value={'Cityrama'}>Anabela</MenuItem>
                      <MenuItem value={'Rodest'}>Eunildes</MenuItem>
                  </Select>
                </FormControl>
                <FormControl size="small" sx={{ minWidth: 180, width: '100%', bgcolor: 'white', marginInlineStart: '0.1rem' }} fullWidth>
                  <InputLabel>Impede a Seleção de</InputLabel>
                  <Select
                      size="small"
                      value={'0'} displayEmpty required={true} label={"Impede a Seleção de"}>
                      <MenuItem value={'Transol'}>Todos</MenuItem>
                      <MenuItem value={'Cityrama'}>Anabela</MenuItem>
                      <MenuItem value={'Rodest'}>Eunildes</MenuItem>
                  </Select>
                </FormControl>
              </Box>
              <Box component={'div'}>
                  <Button size="small" variant="text" sx={{ margin: '0.5rem' }}>Adicionar Nova Regra +</Button>
              </Box>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', marginBlock: '1rem' }}>
            <Box sx={{ width: '50%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start'}}>
                <Typography variant="body1">Apresentar Bonificações na App Mobile</Typography>
                <Tooltip title="Open settings" sx={{ marginBlockStart: '0.2rem', marginInlineStart: '0.5rem'}}>
                  <InfoOutlinedIcon fontSize="small" />
                </Tooltip>
              </Box>
            </Box>
            <Box sx={{ margin: '0rem 1rem 0 1rem', width: '50%', display: 'flex', justifyContent: 'flex-start'}}>
              <FormControl size="small" sx={{ minWidth: 180, width: '100%', bgcolor: 'white' }} fullWidth>
                <RadioGroup row defaultValue="true" name="radio-buttons-group">
                    <FormControlLabel control={<Radio />} label="Sim - apresentar na App"/>
                    <FormControlLabel control={<Radio />} label="Não - ocultar na App"/>
                </RadioGroup>
                <RadioGroup row defaultValue="true" name="radio-buttons-group">
                  <FormControlLabel labelPlacement="end" control={<Checkbox checked={true} />} 
                  label='Permitir seleção das bonificações pelo Motorista' />
                </RadioGroup>
              </FormControl>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', marginBlock: '1rem' }}>
            <Box sx={{ width: '50%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start'}}>
                <Typography variant="body1">Valor máximo das Gratificações</Typography>
                <Tooltip title="Open settings" sx={{ marginBlockStart: '0.2rem', marginInlineStart: '0.5rem'}}>
                  <InfoOutlinedIcon fontSize="small"/>
                </Tooltip>
              </Box>
            </Box>
            <Box sx={{ margin: '0rem 1rem 0 1rem', width: '50%', display: 'flex', justifyContent: 'flex-start'}}>
              <FormControl size="small" sx={{ minWidth: 180, width: '100%', bgcolor: 'white' }} fullWidth>
                  <TextField size="small" defaultValue="" label="Valor Máximo Gratificações (€)" variant="outlined" />
              </FormControl>
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}

export default BonificationPreferences;